import { withCriticalRetry } from "@utils/apiWrapper";
import axios from "axios";
import { API_BASE_URL } from "initializers/constants";
const create = (ciBuildId, payload) => withCriticalRetry(() => axios.post(`${API_BASE_URL}/reporter/runs/${ciBuildId}/test_entities`, {
    testEntity: payload,
}), { additionalRetryStatusCodes: [422] });
const testEntitiesApi = { create };
export default testEntitiesApi;
//# sourceMappingURL=testEntities.js.map